import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
    apiKey: "AIzaSyB4vYNq_0ujZl5g-g3vUeV2_oRkikLnfHQ",
    authDomain: "writellect-app.firebaseapp.com",
    projectId: "writellect-app",
    storageBucket: "writellect-app.firebasestorage.app",
    messagingSenderId: "946572628025",
    appId: "1:946572628025:web:fd26aa141a551191163de8",
    measurementId: "G-5SGX5KCVBP"
  };

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app); 